import { useEffect, useState } from "react";
import { Row, Col, Card, Typography, Tag, Spin, Empty } from "antd";
import { motion } from "framer-motion";
import DOMPurify from "dompurify";

import logo from "src/assets/logos/company.png";
import { getCookie, setCookie } from "./common/utils/cookies";
import { LoadingOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const ForceClear = () => {
  const [countdown, setCountdown] = useState(3);
  const rawHtml = localStorage.getItem("new_version_description") || "";
  const safeHtml = DOMPurify.sanitize(rawHtml);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    const timeout = setTimeout(() => {
      localStorage.clear();
      sessionStorage.clear();

      if ("caches" in window) {
        caches.keys().then((names) => {
          names.forEach((name) => caches.delete(name));
        });
      }

      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          registrations.forEach((reg) => reg.unregister());
        });
      }

      setCookie("version", getCookie("new_version") || "");
    }, countdown * 1000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  return (
    <Row
      justify="center"
      align="middle"
      style={{ minHeight: "100vh", padding: "20px" }}
    >
      <Col xs={24} sm={20} md={16} lg={10} xl={8}>
        {countdown <= 0 ? (
          <div
            style={{
              height: "100vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spin size="large" indicator={<LoadingOutlined spin />} />
          </div>
        ) : (
          <Card
            bordered={false}
            style={{
              textAlign: "center",
              width: "100%",
              boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
              borderRadius: "20px",
              padding: "30px",
            }}
          >
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <img
                src={logo}
                alt="Logo"
                style={{ width: "60%", marginBottom: "20px" }}
              />
            </motion.div>

            <Tag color="warning" style={{ fontSize: "20px", padding: "10px" }}>
              {localStorage.getItem("new_version")}
            </Tag>
            <br />
            {safeHtml ? (
              <div
                style={{ fontSize: "1rem", lineHeight: "1.6" }}
                dangerouslySetInnerHTML={{ __html: safeHtml }}
              />
            ) : (
              <Empty description="No update description found" />
            )}
            <br />
            <Text>Please do not close the tab or window.</Text>
            <br />
            <Text>
              Refreshing in <Text strong>{countdown}</Text> second
              {countdown !== 1 ? "s" : ""}...
            </Text>
          </Card>
        )}
      </Col>
    </Row>
  );
};

export default ForceClear;
